<template>
  <layout-default-appbar :backTo="rota">
      Detalhes
  </layout-default-appbar>
</template>

<script>
import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';

import { ROUTE_LOTE } from '@/constants/ROUTES';

export default {
  name: 'ViewFrotaAppBar',

  components: {
    LayoutDefaultAppbar,
  },

  data() {
    return {
      rota: ROUTE_LOTE,
    }
  }
};
</script>
